<template>
  <section>
    <Article
      v-for="article in list"
      v-bind:key="article._link"
      v-bind:article="article"
      v-bind:index="article._id"
      @view-article="$emit('view-article', $event)"
    />
  </section>
</template>

<script setup lang="ts">
import { isNil } from 'lodash-es'
import Article from './Article.vue'
import { getQueryParams } from './utils'

const props = defineProps({
  limit: {
    type: Number,
    default: 0,
  },
  surround: {
    type: String,
    default: ''
  }
})

const query = computed(() =>getQueryParams())

const { data } = await useAsyncData('repost-feed-list', () =>
  queryContent(query.value).findSurround(
    props.surround,
    { before: props.limit, after: props.limit}
  ),
)

const list = computed(() => data.value
  ? data.value.filter((n) => !isNil(n)).slice(-3)
  : [])
</script>

<style scoped>
</style>
